<template>
  <div class="thumbnail" :style="{ backgroundImage: 'url(\'' + imageUrl + '\')' }"></div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      imageUrl: String
    },
    mounted() {
      console.log(this.imageUrl);
    }
  }
</script>

<style lang="stylus" src="./thumbnail.styl" scoped></style>



// WEBPACK FOOTER //
// thumbnail.vue?17739ee4